<script setup lang="ts" name="SharedShipmentCard">
import InfoTooltip from '~/components/InfoTooltip.vue';

defineProps<{
  title?: string;
  tooltipTitle?: string;
  tooltipDescription?: string;
}>();
</script>

<template>
  <div class="rounded-md border border-charcoal-3 p-5">
    <div class="flex h-[40px] justify-between">
      <p v-if="title" class="text-subtitle-1 text-charcoal-9">{{ title }}</p>

      <InfoTooltip
        v-if="tooltipDescription"
        :title="tooltipTitle"
        :description="tooltipDescription"
      />
      <slot name="actions" />
    </div>

    <slot />
  </div>
</template>
